import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import LoadingCircle from "../../loadingCircle/LoadingCircle";

type ProceedButtonVariant = "text" | "outlined" | "contained";

interface ProceedButtonProps {
  onProceed: () => void;
  disabled?: boolean;
  loading?: boolean;
  value?: string;
  variant?: ProceedButtonVariant;
}

const ProceedButton = (props: ProceedButtonProps) => {
  const { t } = useTranslation();
  const { disabled, loading, onProceed, value, variant } = props;

  const disableButton = disabled || loading;

  return (
    <Button
      data-testid="proceed-button"
      disabled={disableButton}
      onClick={onProceed}
      size="medium"
      variant={variant}
    >
      {value ? t(value) : t("proceed")}
      {loading && <LoadingCircle className="ml-10" size={16} />}
    </Button>
  );
};
export default ProceedButton;
